export default {
  partners: [],
  pagination: {},
  hotel: {}
}
